import { getSelectedOption } from '../../studentFile/updateStudentFile/utils/selectFormat';
import {
  LessonTeacherJustificationSubmitData,
  optionsSelectLessonTeacher,
  TeacherAttendanceFile,
} from '../types';
import dayjs from 'dayjs';

export const lessonStatus = [
  { label: 'Registrada tarde', value: 'registrada-tarde' },
  { label: 'Iniciada tarde', value: 'iniciada-tarde' },
  { label: 'No ejecutada', value: 'no-ejecutada' },
];

export const getLessonStatus = (status: string) => {
  return lessonStatus.find((item) => item.value === status);
};

export const convertSubmitToFields = (lessonId: number, values: any) => {
  const justificationFiles = (values.justification?.fileGroup || []).map(
    (file: TeacherAttendanceFile) => ({
      ...file,
      isFromAdmin: false,
    }),
  );
  const observationFiles = (values.observation?.fileGroup || []).map(
    (file: TeacherAttendanceFile) => ({
      ...file,
      isFromAdmin: true,
    }),
  );
  const allFiles = [...justificationFiles, ...observationFiles];

  const payload = {
    // Justification
    [`justificationDescription_${lessonId}`]:
      values.justification?.description || null,
    [`justificationCreatedBy_${lessonId}`]:
      values.justification?.createdByName || null,
    [`justificationCreatedAt_${lessonId}`]: values.justification?.createdAt
      ? dayjs(values.justification.createdAt).format('DD/MM/YYYY')
      : null,
    [`status_${lessonId}`]: getSelectedOption(
      values.justification?.status,
      optionsSelectLessonTeacher,
    ),
    // Observation
    [`observationDescription_${lessonId}`]:
      values.observation?.description || null,
    [`observationCreatedBy_${lessonId}`]:
      values.observation?.createdByName || null,
    [`observationCreatedAt_${lessonId}`]: values.observation?.createdAt
      ? dayjs(values.observation.createdAt).format('DD/MM/YYYY')
      : null,
    // Files
    [`complementaryFilesIds_${lessonId}`]: allFiles.map(
      (e: TeacherAttendanceFile) => ({
        ...e,
      }),
    ),
  };

  return payload;
};

export const convertFieldsToSubmit = (
  lessonId: number,
  values: any,
): LessonTeacherJustificationSubmitData => {
  const descriptionKey = `justificationDescription_${lessonId}`;
  const complementaryFilesKey = `complementaryFilesIds_${lessonId}`;

  const payload = {
    lessonId: Number(lessonId),
    description: values[descriptionKey],
    fileIds: (values[complementaryFilesKey] || [])
      .filter((file: TeacherAttendanceFile) => !file?.isFromAdmin)
      .map((file: TeacherAttendanceFile) => file.id),
  };

  return payload;
};
